// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import React from 'react';

export const Content_context = React.createContext({
    footer_content: null,
    header_content: null,
    set_f_content: ()=>{},
    set_h_content: ()=>{},
});
